/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api\index.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Account Menu module.
────────────────────────────────────────────────────────────────*/


import { buildApiUrl, getApiHeaders } from '../../../config/api';

export interface LicenseStatus {
    mode: 'community' | 'licensed';
    status: string;
    max_extensions: number;
    extensions_used: number;
    expires_at: string | null;
    days_remaining: number | null;
    license_key: string | null;
    hardware_id: string;
}

export async function getLicenseStatus(): Promise<LicenseStatus> {
    const response = await fetch(buildApiUrl('/api/licensing/status'), {
        method: 'GET',
        headers: getApiHeaders(),
    });

    if (!response.ok) {
        throw new Error('Failed to get license status');
    }

    return response.json();
}

export async function activateLicense(licenseKey: string): Promise<{ success: boolean; message?: string; error?: string }> {
    const response = await fetch(buildApiUrl('/api/licensing/activate'), {
        method: 'POST',
        headers: getApiHeaders(),
        body: JSON.stringify({ license_key: licenseKey }),
    });

    return response.json();
}

export async function validateLicense(): Promise<{ valid: boolean; message: string }> {
    const response = await fetch(buildApiUrl('/api/licensing/validate'), {
        method: 'POST',
        headers: getApiHeaders(),
        body: JSON.stringify({}),
    });

    return response.json();
}

export async function deactivateLicense(): Promise<{ success: boolean; message?: string; error?: string }> {
    const response = await fetch(buildApiUrl('/api/licensing/deactivate'), {
        method: 'POST',
        headers: getApiHeaders(),
        body: JSON.stringify({}),
    });

    return response.json();
}
